<template>
  <div class="label-container">
  <div id="label">
    Anomalies: {{ stats?.anomalies ?? 'N/A'}} | 
    Incidents: {{ stats?.incidents ?? 'N/A'}} <br>
    Unique vessels with anomalies: {{ stats?.vessels ?? 'N/A'}}
  </div>
  </div>
</template>

<script>
export default {
  name: "CurrentMapStats",
  props: {
    stats: Object,
  }
}
</script>

<style scoped>
.label-container {
  position: absolute;
  bottom: 68px;
  right: 2px;
  z-index: 1;
}

.label-container > * {
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 11px;
  line-height: 18px;
  display: block;
  margin: 0;
  padding: 5px 10px;
  border-radius: 3px;
}
</style>